import React from 'react';
import LoadingSpinner from './LoadingSpinner';
import MaintenanceBanner from './MaintenanceBanner';
import { useAuthContext } from '../../contexts/AuthContext';

/** Holds the app behind the boot refresh, so no page renders signed out and then flips. */
const AuthScreen = ({ children }) => {
  const { isLoading } = useAuthContext();
  if (isLoading) {
    return <LoadingSpinner message="Initializing authentication..." />;
  }
  return children;
};

// The maintenance bar sits above every state (loading, signed out, and the signed-in app),
// because during planned downtime a signed-in user lands on an in-app error, not the login.
const AuthWrapper = ({ children }) => (
  <>
    <MaintenanceBanner />
    <AuthScreen>{children}</AuthScreen>
  </>
);

export default AuthWrapper;
